module.exports = __webpack_public_path__ + "assets/img/CTA-cartoucherie-7etapes2.b9327ba9.jpg";